module.exports = __webpack_public_path__ + "0acd4591db4b6fb9e61028dccf76c545.svg";